const GLIDER = ".glider";
const SCROLL = "scroll";
const HIDDEN = "hidden";

let slideNumber = 0;

const initGliderSwipe = () => {
    const gliders = document.querySelectorAll(GLIDER);
    for (const glider of gliders) {
        glider.addEventListener(SCROLL, () => {
            touchHandler(glider);
        });
    }
}

const touchHandler = (glider) => {
    const currentSlide = glider._glider.getCurrentSlide();
    if (slideNumber !== currentSlide) {
        slideNumber = currentSlide;
        glider.style.overflowX = HIDDEN;
        setTimeout(() => {
            glider.style.overflowX = SCROLL;
        }, 1);
    }
}
export { initGliderSwipe };
